/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { get } from '@ember/object';
import { didCancel, task } from 'ember-concurrency';
import { queryEncode } from 'cio/helpers/query';
import DS from 'ember-data';
import SegmentModel from 'cio/models/segment';

interface SegmentPeopleCountArgs {
  segment: SegmentModel | DS.PromiseObject<SegmentModel>;
  didLoadCount?: (count: number) => unknown;
}

export default class SegmentPeopleCount extends Component<SegmentPeopleCountArgs> {
  get filters() {
    return queryEncode({
      and: [
        {
          // @ts-ignore: nested key look-up
          // keeping get(...) for compatibility after TS/Glimmer conversion:
          segment: { id: get(this.args, 'segment.id') }, // eslint-disable-line ember/no-get
        },
      ],
    });
  }

  loadCount = task({ drop: true }, async () => {
    let segment = await this.args.segment;
    let count = await segment.loadPeopleCount();
    this.args.didLoadCount?.(count);
    return count;
  });

  constructor(owner: unknown, args: SegmentPeopleCountArgs) {
    super(owner, args);

    this.loadCount.perform().catch((e) => {
      // ignore cancellation errors (happens in tests):
      if (!didCancel(e)) {
        throw e;
      }
    });
  }
}
